export default (api) => ({
  getRejectedApplications: (params) => api.get('/finxp/rejected', { params }),
  updateRejectedApplication: (data) => api.put('/finxp/updateapplication', data)
})
